// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutLogo_container__1bXtS","helper":"AboutLogo_helper__thFvH","img":"AboutLogo_img__2gfCE"};